<mat-progress-bar
  *ngIf="pageState === 'waiting'"
  mode="indeterminate"
></mat-progress-bar>

<div *ngIf="pageState === 'error'" class="extra-narrow-content">
  <mat-card>
    <mat-card-header>
      <mat-card-title> Space not found. </mat-card-title>
    </mat-card-header>
  </mat-card>
</div>

<div *ngIf="pageState === 'ready'" class="extra-narrow-content">
  <mat-card>
    <mat-card-content>
      <h1>Space settings</h1>

      <h3 *ngIf="!canEditName">Name: {{ name }}</h3>
      <div *ngIf="canEditName" class="edit-text">
        <mat-form-field class="auto-margin">
          <mat-label>Name</mat-label>
          <input
            [formControl]="nameControl"
            matInput
            [readonly]="!canEditName"
            (keydown.enter)="saveName()"
          />
        </mat-form-field>
        <div class="auto-margin" *ngIf="canEditName">
          <button
            mat-raised-button
            color="primary"
            [disabled]="!nameChanged || nameUpdateState === 'waiting'"
            (click)="saveName()"
          >
            <mat-icon *ngIf="nameUpdateState === 'waiting'">
              <mat-spinner
                [color]="'accent'"
                [mode]="'indeterminate'"
                [diameter]="20"
              >
              </mat-spinner>
            </mat-icon>
            {{
              nameUpdateState === 'waiting'
                ? 'Saving'
                : nameUpdateState === 'complete'
                ? 'Saved'
                : 'Save'
            }}
          </button>
        </div>
      </div>

      <div class="standard-list">
        <div class="header-button">
          <h3 class="auto-margin">Users</h3>
        </div>
        <div>
          <div *ngFor="let user of users" class="list-item">
            <div class="list-item-title">
              {{ user.name }}
              <span *ngIf="user.admin" class="dim-text"
                >&nbsp;&nbsp;Admin
              </span>
            </div>

            <button
              *ngIf="isAdmin"
              mat-stroked-button
              (click)="removeUser(user._id)"
            >
              REMOVE
            </button>
          </div>
        </div>
        <p *ngIf="users.length === 0" class="no-entries">No users in space</p>
        <div
          *ngIf="isAdmin && possibleUsers && !showAddUsers"
          class="add-button"
        >
          <button mat-button (click)="showAddUsers = true">
            <mat-icon mat-button-icon>add</mat-icon>
            Add users
          </button>
        </div>
        <div class="search-field">
          <mat-form-field *ngIf="showAddUsers">
            <mat-label>Add users</mat-label>
            <input
              matInput
              aria-label="Add users"
              [matAutocomplete]="userAutocomplete"
              [formControl]="selectUserControl"
            />
            <mat-autocomplete
              autoActiveFirstOption
              (optionSelected)="selected($event.option.value)"
              #userAutocomplete="matAutocomplete"
            >
              <mat-option
                disabled
                *ngIf="possibleUsers && filteredUsers.length === 0"
              >
                No matching users.
              </mat-option>
              <mat-option disabled *ngIf="!possibleUsers">
                No more users to add.
              </mat-option>
              <mat-option
                class="user-option"
                *ngFor="let user of filteredUsers"
                [value]="user._id"
              >
                <div class="positioner">
                  <div class="name">
                    {{ user.name }}
                  </div>
                  <button mat-stroked-button>
                    <mat-icon>add</mat-icon>Add
                  </button>
                </div>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
